import React, { useState } from "react";
import {
  Card,
  Button,
  Image,
  Badge,
} from "../../common/utils/antd-imports/AntdImports";
import { truncateDescriptionText, formatDate } from "../utils/Utils";
import "./NotificationPopoverContent.css";
import BellIcon from "../../../assests/notification-bell-icon.svg";
import { useNavigate } from "react-router-dom";
import "../../../main.css";
import { setBreadcrumbs } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotifications,
  updateNotifications,
} from "../../../store/thunks/common-thunks/commonThunk";

const NotificationPopoverContent = ({
  notificationsList,
  setOpenNotificationPopover,
}) => {
  const { user } = JSON.parse(localStorage.getItem("user"));
  const userType = user?.user_type === "owner" ? "seller" : "buyer";
  const navigate = useNavigate();
  const breadcrumbs = useSelector((state) => state.breadcrumb);

  const [tabValue, setTabValue] = useState("saved_campaign");
  const dispatch = useDispatch();
  const goToSubPage = ({ title, path }) => {
    const updatedCrumbs =
      breadcrumbs &&
      breadcrumbs?.filter((crumb) => !/^[a-z0-9]{8,}$/i.test(crumb.path));

    // Add Cart crumb
    updatedCrumbs.push({
      title,
      path,
    });

    dispatch(setBreadcrumbs(updatedCrumbs));
  };
  const markAsRead = (id) =>
    dispatch(updateNotifications({ notification_ids: [id] })).then((res) => {
      if (res?.payload?.status == 1) {
        dispatch(getNotifications());
        setOpenNotificationPopover(false);
      }
    });

  // Navigation to different screens based on the notification type
  const viewCampaignDetails = (record) => {
    switch (record?.type) {
      case "offer_rejected":
      case "offer_accepted":
      case "transfer_campaign":
        goToSubPage({
          title: "Campaigns",
          path: `/${userType}/mycampaigns?segment=${tabValue}`,
        });
        navigate(`/${userType}/mycampaigns?segment=${tabValue}`, {
          replace: true,
        });
        markAsRead(record?.id);
        break;

      case "campaign":
        if (userType === "seller") {
          goToSubPage({
            title: record?.c_name,
            path: `/${userType}/viewCampaigns/campaignDetails/${btoa(
              record?.campaign_id,
            )}`,
          });
          navigate(
            `/${userType}/viewCampaigns/campaignDetails/${btoa(
              record?.campaign_id,
            )}`,
          );
        } else {
          goToSubPage({
            title: record?.c_name,
            path: `/${userType}/campaigndetails?_id=${btoa(
              record?.campaign_id,
            )}`,
          });
          navigate(
            `/${userType}/campaigndetails?_id=${btoa(record?.campaign_id)}`,
          );
        }
        markAsRead(record?.id);
        break;

      case "bulk_upload":
      case "product_transfer":
        goToSubPage({
          title: "My Products",
          path: `/${userType}/myproducts`,
        });
        navigate(`/${userType}/myproducts`);
        markAsRead(record?.id);
        break;

      case "rfp_request":
        goToSubPage({
          title: "RFP Requests",
          path: `/${userType}/rfpRequests`,
        });
        navigate(`/${userType}/rfpRequests`);
        markAsRead(record?.id);
        break;

      case "offer_request":
        goToSubPage({
          title: "My Products",
          path: `/${userType}/viewCampaigns`,
        });
        navigate(`/${userType}/viewCampaigns`);
        markAsRead(record?.id);
        break;

      case "term_request":
        goToSubPage({
          title: "Buyer Request",
          path: `/${userType}/terms-requests`,
        });
        navigate(`/${userType}/terms-requests`);
        markAsRead(record?.id);
        break;
      case "hold_request":
        if (userType === "seller") {
          goToSubPage({
            title: "Buyer Request",
            path: `/${userType}/terms-requests`,
          });
          navigate(`/${userType}/terms-requests`);
        }
        markAsRead(record?.id);
        break;
      default:
        console.warn(`Unhandled campaign type: ${record?.type}`);
    }
  };

  return (
    <div className="notification-popover-content">
      {notificationsList.length > 0 ? (
        <>
          {notificationsList?.slice(0, 4)?.map((notification) => {
            return (
              <Card key={notification?.id}>
                <div className="description">
                  {notification?.desc}
                  {notification?.status === 0 && (
                    <Badge dot={true} color="#d2042d"></Badge>
                  )}
                </div>
                <div style={{ fontFamily: "Roboto" }}>
                  {truncateDescriptionText(notification.message)}
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {" "}
                  {notification?.type != "bulk_upload_pending" &&
                    notification?.type != "campaign_product_offer" && (
                      <Button
                        className="view-details pointer"
                        onClick={() => viewCampaignDetails(notification)}
                      >
                        View Details
                      </Button>
                    )}
                  <div className="notify-date">
                    {formatDate(notification?.created_at)}
                  </div>
                </div>
              </Card>
            );
          })}
        </>
      ) : (
        <>
          <div className="image-container">
            <Image
              src={BellIcon}
              className="no-notifications-icon"
              preview={false}
            />
          </div>
          <div className="content-section">
            <div className="no-new-header">No New Notifications Yet!</div>
            <span className="sub-message">
              Stay tuned! Any updates about your campaigns, offers, or transfers
              will show up right here.
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationPopoverContent;
